import { CartItem } from "@/types/cart";

const FREE_DUMPLING_ID = 1510;
const PORK_XIAOLONG_BAO_ID = 174;
const FREE_PORK_XIAOLONG_BAO_ID = 1918;
const FREE_ITEM_IDS = [FREE_DUMPLING_ID, FREE_PORK_XIAOLONG_BAO_ID];

export const applyBranch10Promotion = (cart: CartItem[]): CartItem[] => {
  const hasCategory157Items = cart.some((item) => item.category === 157);
  const hasDailySpecialItems = cart.some((item) => item.is_daily_special);
  const newCart: CartItem[] = cart.filter(
    (item) => !FREE_ITEM_IDS.includes(item.id),
  );

  // If cart has category 157 items OR daily special items, remove free items and don't apply promotion
  if (hasCategory157Items || hasDailySpecialItems) {
    return newCart;
  }

  const subtotal = newCart.reduce(
    (total, item) =>
      total + parseFloat(item?.unit_price ?? "0.00") * item.quantity,
    0,
  );

  if (subtotal >= 30) {
    newCart.push({
      id: FREE_DUMPLING_ID,
      name: "Fried Dumpling (Free)",
      unit_price: "0.00",
      quantity: 1,
      selected_options: {},
      uniqueId: "free_dumpling",
      description: "",
      image:
        "https://redbirdimages.s3.amazonaws.com/images/6099bb38fc9e4d2fa6f4ff74b8f116c3",
      product_option_lists: [],
      is_upsell: false,
      is_free_item: true,
    });

    // Buy one Pork Xiaolong Bao, get one free (one per order)
    if (newCart.some((item) => item.id === PORK_XIAOLONG_BAO_ID)) {
      newCart.push({
        id: FREE_PORK_XIAOLONG_BAO_ID,
        name: "Pork Xiaolong Bao (Free)",
        unit_price: "0.00",
        quantity: 1,
        selected_options: {},
        uniqueId: "free_pork_xiaolong_bao",
        description: "",
        image:
          "https://d280f90ni0um3o.cloudfront.net/products/China Queen-Pork Xiaolong Bao/1744074659.2942693.jpeg",
        product_option_lists: [],
        is_upsell: false,
        is_free_item: true,
      });
    }
  }

  return newCart;
};
